import { defineComponent, onMounted } from 'vue'

export default defineComponent({
    name: 'DefaultLayout',
    setup() {
        onMounted(() => {
            document.title = 'Dermoscopy Cloud'
        })

        return {}
    }
})